import React from 'react';
import { Link } from 'react-router-dom';
import { Utensils, MoreHorizontal, LogIn, Info, HelpCircle, Lightbulb, Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const HomepageGuestHeader: React.FC = () => {
  return (
    <header className="border-b border-golden-light bg-cream shadow-sm w-full py-3 px-4">
      <div className="flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 text-xl font-bold text-charcoal font-playfair">
          <Utensils className="h-7 w-7 text-sage" />
          <span className="text-sage lowercase">forkast</span>
        </Link>
        
        <div className="flex items-center gap-1 md:gap-3">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="relative h-8 w-8 rounded-full">
                <Avatar className="h-8 w-8">
                  <AvatarFallback className="bg-sage text-white">
                    <MoreHorizontal className="h-4 w-4" />
                  </AvatarFallback>
                </Avatar>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-56" align="end" forceMount>
              {/* Welcome Header */}
              <div className="flex items-center gap-3 p-3 pb-2">
                <Avatar className="h-8 w-8">
                  <AvatarFallback className="bg-sage text-white text-xs">
                    !
                  </AvatarFallback>
                </Avatar>
                <div className="flex flex-col min-w-0 flex-1">
                  <p className="text-sm font-medium">Welcome!</p>
                </div>
              </div>
              <DropdownMenuSeparator />
              
              <DropdownMenuItem asChild>
                <Link to="/auth/login" className="w-full">
                  <LogIn className="mr-2 h-4 w-4" />
                  <span>Sign In</span>
                </Link>
              </DropdownMenuItem>
              
              <DropdownMenuSeparator />
              
              <DropdownMenuItem asChild>
                <Link to="/how-forkast-meal-planning-works" className="w-full">
                  <Info className="mr-2 h-4 w-4" />
                  <span>How it works</span>
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link to="/meal-planning-tips" className="w-full">
                  <Lightbulb className="mr-2 h-4 w-4" />
                  <span>Tips</span>
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link to="/meal-planning-app-faqs" className="w-full">
                  <HelpCircle className="mr-2 h-4 w-4" />
                  <span>FAQs</span>
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link to="/install" className="w-full">
                  <Download className="mr-2 h-4 w-4" />
                  <span>Install App</span>
                </Link>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
};

export default HomepageGuestHeader;